import { string, shape, bool, func } from 'prop-types';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import { getFooterResouceByMediaType } from '../../../../utils/helperFunctions';

const APCardFooter = ({ type }) => {
	const mediaType = type?.toLowerCase() || '';

	switch (mediaType) {
		case 'video':
			return (
				<>
					<PlayCircleOutlineIcon fontSize="small" />
					<Typography component="p" variant="subtitle2" color="textSecondary">
						Video
					</Typography>
				</>
			);
		case 'audio':
			return (
				<>
					<VolumeUpOutlinedIcon fontSize="small" />
					<Typography component="p" variant="subtitle2" color="textSecondary">
						Audio
					</Typography>
				</>
			);
		default:
			return (
				<>
					<ArticleOutlinedIcon fontSize="small" />
					<Typography component="p" variant="subtitle2" color="textSecondary">
						Article
					</Typography>
				</>
			);
	}
};

APCardFooter.propTypes = {
	type: string.isRequired,
};

/**
 *
 * VPTRX Card
 *
 * This component is the card used inside of HEPWidget. It is extracted into its own sharable component here because EVE is currently working on finalizing Cards. Code for this card lives here for now, can be cut and copied into shared component lib at some point in the future instead.
 */
const VirtualMSKResourceMemberCard = ({
	resource,
	navigateToResourceLibrary,
}) => {
	const { title, thumbnail, type } = resource;
	const { footerText, footerIcon } = getFooterResouceByMediaType(type);

	return (
		<CardActionArea
			onClick={() => {
				navigateToResourceLibrary(resource.id);
			}}
			sx={{
				// Ensure that the clickable area of each card takes the full grid item area
				height: '100%',
			}}
			data-testid="msk-member-resource-card"
		>
			<Card
				elevation={3}
				sx={{
					// Ensure that each card takes the full grid item area
					height: '100%',
					minWidth: '200px',
				}}
			>
				<Stack direction="column" height="100%">
					{thumbnail && (
						<CardMedia
							sx={{
								height: { sm: 200, xs: 165 },
							}}
							image={thumbnail}
							component="img"
							title="Video demonstration of this exercise"
							alt="Video demonstration of this exercise"
						/>
					)}
					<CardContent sx={{ flexGrow: '1' }}>
						<Stack mt={1}>
							<Stack direction="column">
								<Typography component="h2" variant="subtitle1" gutterBottom>
									{title}
								</Typography>
							</Stack>
						</Stack>
					</CardContent>
					<CardActions disableSpacing>
						<Stack
							direction="row"
							spacing={1}
							alignItems="center"
							ml={1}
							mb={1}
							mt="auto"
						>
							<>
								{footerIcon}
								<Typography
									component="p"
									variant="subtitle2"
									color="textSecondary"
								>
									{footerText}
								</Typography>
							</>
						</Stack>
					</CardActions>
				</Stack>
			</Card>
		</CardActionArea>
	);
};
VirtualMSKResourceMemberCard.propTypes = {
	resource: shape({
		title: string,
		mediaPath: string,
		subtitles: string,
		thumbnail: string,
		id: string,
		type: string,
		visited: bool,
	}).isRequired,
	navigateToResourceLibrary: func.isRequired,
};
VirtualMSKResourceMemberCard.defaultProps = {};

export default VirtualMSKResourceMemberCard;
